const SUPPLY_CHAIN_MANAGER_LINK = '/admin/metadata-admin-manager'

export {
    SUPPLY_CHAIN_MANAGER_LINK
}